module.exports = __webpack_public_path__ + "img/ourTipp@2x.d00ddb5.jpg";